import { jsx as n } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import { c as i } from "./cn-DlLpp5ix.js";
const g = {
  active: "w-8",
  completed: "w-[18px]",
  upcoming: "w-2.5"
}, b = {
  active: "bg-accent",
  completed: "bg-accent",
  upcoming: "bg-border-strong"
}, f = u(
  function({
    current: o,
    total: e = 6,
    className: c,
    "aria-label": s,
    "aria-valuetext": d,
    ...l
  }, m) {
    const t = Math.max(1, Math.min(o, e));
    return /* @__PURE__ */ n(
      "div",
      {
        ref: m,
        role: "progressbar",
        "aria-valuemin": 1,
        "aria-valuemax": e,
        "aria-valuenow": t,
        "aria-valuetext": d,
        "aria-label": s,
        "data-ls-composite": "onboarding-step-indicator",
        className: i("flex items-center justify-center gap-1.5", c),
        ...l,
        children: Array.from({ length: e }, (x, p) => {
          const a = p + 1, r = a < t ? "completed" : a === t ? "active" : "upcoming";
          return /* @__PURE__ */ n(
            "span",
            {
              "aria-hidden": "true",
              "data-state": r,
              "data-step": a,
              className: i(
                "inline-block h-1 rounded-full transition-all duration-fast ease-out",
                g[r],
                b[r]
              )
            },
            a
          );
        })
      }
    );
  }
);
f.displayName = "OnboardingStepIndicator";
export {
  f as O
};
//# sourceMappingURL=OnboardingStepIndicator-B0gk5NIb.js.map
